// Sessiya davomidagi xotira keshi: bir xil kalit uchun so'rov faqat bir marta ketadi.
// Muvaffaqiyatsiz so'rov keshda qolmaydi (keyingi safar qayta urinish mumkin).
const store = new Map();

export function cached(key, loader) {
  if (!store.has(key)) {
    const promise = Promise.resolve()
      .then(loader)
      .catch((error) => {
        store.delete(key);
        throw error;
      });
    store.set(key, promise);
  }
  return store.get(key);
}

export function clearCache() {
  store.clear();
}
